import React, { Component } from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { Grid } from 'semantic-ui-react';
import { connect } from 'react-redux';

import Header from './components/Header';
import Projects from './scenes/projects';
import Analysis from './scenes/analysis';
import NotFound from './containers/NotFound';

export const SECTION_PROJECTS = 'projects';
export const SECTION_ANALYSIS = 'analysis';

class App extends Component {
  render() {
    return (
      <Grid celled>
        <Header />
        <Switch>
          <Route exact path="/" render={() => <Redirect to="/projects" />} />
          <Route path="/projects" component={Projects} />
          <Route path="/analysis" component={Analysis} />
          <Route component={NotFound} />
        </Switch>
      </Grid>
    );
  }
}

export default withRouter(connect()(App));



// WEBPACK FOOTER //
// ./src/App.js